export const r4 = '4px';
export const r8 = '8px';
export const r16 = '16px';

export const radius = {
  r4,
  r8,
  r16,
  /** 4 pixels */
  small: r4,
  /** 8 pixels */
  medium: r8,
  /** 16 pixels */
  large: r16,
  /** full circle */
  full: '9999px',
};

export type Radius = keyof typeof radius;
